<template>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="名称">
        <el-input v-model="searchForm.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" @click="search()">搜索</el-button>
          <el-button type="primary" @click="showAdd()">新建</el-button>
      </el-form-item>
    </el-form>
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="角色名称" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所属组织" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.orgName || '--' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间">
        <template #default="scope">
          <div>
            <span>{{ scope.row.createTime }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 对话框--新建 -->
    <el-dialog v-model="dialogFormVisible" :title="is_update?'编辑角色':'新建角色'" width="500" :close-on-click-modal="false" destroy-on-close>
        <el-form ref="addFormRef" :model="addInfo" :rules="addRules" label-position="right" label-width="auto">
        <el-form-item label="角色名称" prop="name">
            <el-input v-model="addInfo.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="所属组织" prop="orgId">
          <el-tree-select
            v-model="addInfo.orgId"
            :data="treeSelectData"
            check-strictly
            :render-after-expand="false"
            show-checkbox
          />
        </el-form-item>
        <el-form-item label="权限">
            <el-tree
                v-show="treeData.length>0"
                :data="treeData"
                :props="defaultProps"
                node-key="id"
                :default-checked-keys="defaultCheckedKeys"
                @check="handleCheckChange"
                show-checkbox
                filter-node-method="filterNode"
                ref="tree"
            ></el-tree>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            v-model="addInfo.description"
            :autosize="{ minRows: 3, maxRows: 6 }"
            type="textarea"
            maxlength="500"
            placeholder="请输入角色描述"
          />
        </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="save()">确定</el-button>
        </div>
        </template>
    </el-dialog>

    <!-- 对话框--删除 -->
    <el-dialog
      v-model="centerDialogVisible"
      title="提示"
      width="500"
      align-center
    >
      <span>确定删除该角色？</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deleteRole()">确定</el-button>
        </div>
      </template>
    </el-dialog>

  </template>
  
  <script>
  import { ElMessage } from 'element-plus';
  import { required } from '@/utils/validators';
  export default {
  name:'RoleList',
  data() {
    return {
      searchForm:{
        name:'',
      },
        filterText: '',
        centerDialogVisible:false,
        currt_id:'', //当前操作id
        is_used_role:false,//是否已使用角色
        is_update:0, //编辑/新增
        treeSelectData:[],
        treeData: [
            // 填充你的树形数据
            // {
            //     id: 1,
            //     label: '设备管理',
            //     children: [
            //     {
            //         id: 101,
            //         label: '充电设备管理'
            //     },
            //     ]
            // },
            // {
            //     id: 2,
            //     label: '用户管理',
            //     children: [
            //     {
            //         id: 201,
            //         label: '角色管理'
            //     },
            //     {
            //         id: 202,
            //         label: '权限管理'
            //     }
            //     ]
            // }
        ],
        defaultCheckedKeys: [], // 设置默认勾选的节点id数组
        checkedKeys: [], // 存储当前勾选的节点id
        defaultProps: {
            children: 'children',
            label: 'label'
        },
        dialogFormVisible:false,
        tableData:[
            // {
            //     name:'系统管理员',
            //     type_name:'设备管理,用户管理',
            //     create_time:'2018-08-08'
            // }
        ],
        total: 0, //总条数
        currentPage: 1, //当前页
        pageSize: 10, //每页显示条数
        addFormRef: null,
        addRules: {
          name: [required('请输入角色名称')],
          orgId: [required('请选择所属组织')],
        },
        addInfo:{
            id:'',
            name: '',
            code:'',
            description:'',
            permissionsIds: [],
        },
        roleTreeProps:{
            label: 'name',
            children: 'zones',
        }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  computed: {
    filteredMessage() {
      // 这里可以实现类似过滤器的转换逻辑
    }
  },
  beforeCreate(){
    
  },
  created(){
    
  },
  mounted(){
    this.getList();
    this.getTreeList();
    this.getOrgList();
  },
  methods:{
    //搜索
    search(){
      this.currentPage = 1;
      this.getList();
    },
    handleSizeChange (val) { //每页显示条数
        this.pageSize = val;
        this.currentPage = 1;
        this.getList();
    },
    handleCurrentChange(val) { //当前页
        this.currentPage = val;
        this.getList(); //获取列表
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    loadNode(){},
    handleCheckChange(data, checkedInfo) {
      // 合并完整勾选和半选状态的节点，确保父级菜单ID也会被传给后端
      this.addInfo.permissionsIds = [...checkedInfo.checkedKeys, ...checkedInfo.halfCheckedKeys];
    },
    getTreeList(){
      //获取权限树状图
      let that = this;
      let param = [];
      that.$axios.post(that.$store.state.platformApi+"permission/all",JSON.stringify(param)).then(result => {
        // console.log(result);
        if(result.code==200){
          if(result.data.length>0){
            result.data.forEach(item => {
              item.label = item.name;
              if(item.children.length>0){
                item.children.forEach(item2 => {
                  item2.label = item2.name;
                  if(item2.children.length>0){
                    item2.children.forEach(item3 => {
                      item3.label = item3.name;
                    })
                  }
                })
              }
            });
            that.treeData = result.data;
          }
        }
      })
    },
    getOrgList(){
      //获取组织架构树
      let that = this;
      that.$axios.post(that.$store.state.platformApi+"org/tree",{}).then(result => {
        if(result.code==200){
          if(result.data.length>0){
            //返回新的组织架构树数组
            that.treeSelectData = result.data.map(item => ({
              value: item.id,
              label: item.name,
              children: item.children ? item.children.map(item2 => ({
                value: item2.id,
                label: item2.name,
                children: item2.children ? item2.children.map(item3 => ({
                  value: item3.id,
                  label: item3.name,
                  children: item3.children ? item3.children.map(item4 => ({
                    value: item4.id,
                    label: item4.name,
                  })) : []
                })) : []
              })) : []
            }));
            // console.log('组织架构树:',that.treeSelectData);
          }
        }
      })
    },
    getList(){
      //获取角色列表
      let that = this;
      let param = {};
      param.page = that.currentPage;
      param.pageSize = that.pageSize;
      param.name = that.searchForm.name;
      that.$axios.post(that.$store.state.platformApi+"roles/page",JSON.stringify(param)).then(result => {
        // console.log(result);
        if(result.code==200){
          that.tableData = result.data.records;
          that.total = result.data.total; //总条数
          // that.firstMenu = that.tableData.filter(item=>{
          //   return item.parentId==0
          // });
          // console.log(that.firstMenu);
        }
      })
    },
    save(){
      //保存
      let that = this;
      // 表单校验
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return;
        if(that.is_update==1){
          //编辑
          var url = that.$store.state.platformApi+"roles/edit";
        }else{
          //新增
          var url = that.$store.state.platformApi+"roles/add";
        }
        that.$axios.post(url,JSON.stringify(that.addInfo)).then(result => {
          if(result.code==200){
            // 保存成功
            that.dialogFormVisible = false;
            that.getList();
            ElMessage({
              message: '保存成功',
              type: 'success',
            })
          }
        })
      });
    },
    showAdd(){
      //打开新建
        this.is_update = 0;
        this.is_used_role = false;
        this.addInfo = Object.fromEntries(
          Object.keys(this.addInfo).map(key => [key, ''])
        );
        this.addInfo.permissionsIds = [];
        this.dialogFormVisible = true;
        // 默认勾选首页权限
        this.$nextTick(() => {
          if (this.$refs.tree) {
            const homeNode = this.findNodeByName(this.treeData, '首页');
            if (homeNode) {
              this.$refs.tree.setCheckedKeys([homeNode.id]);
              this.defaultCheckedKeys = [homeNode.id];
              this.addInfo.permissionsIds = [homeNode.id];
            } else {
              this.$refs.tree.setCheckedKeys([]);
              this.defaultCheckedKeys = [];
            }
          }
        });
    },
    handleEdit(index,row){
      //打开编辑
      let that = this;
      that.is_update = 1;
      that.defaultCheckedKeys = [];
      that.$axios.post(that.$store.state.platformApi+"roles/view/"+row.id).then(result => {
        // console.log(result);
        if(result.code==200){
          // 过滤掉父级节点ID，只保留叶子节点用于回显，避免父级勾选导致子级全被选中
          let leafIds = that.getLeafNodeIds(that.treeData, result.data.permissionsIds || []);
          that.defaultCheckedKeys = leafIds;
          that.addInfo.id = result.data.id;
          that.addInfo.code = result.data.code;
          that.addInfo.orgId = result.data.orgId;
          that.addInfo.name = result.data.name;
          that.addInfo.permissionsIds = result.data.permissionsIds ? result.data.permissionsIds:[];
          that.addInfo.description = result.data.description ? result.data.description:'';
          that.dialogFormVisible = true;
          // default-checked-keys 动态变更只追加勾选不清除旧勾选，必须用 setCheckedKeys 全量重置，
          // 否则连续编辑不同角色时权限树会残留上次勾选
          that.$nextTick(() => {
            if (that.$refs.tree) {
              that.$refs.tree.setCheckedKeys(leafIds);
            }
          });
        }
      })
      that.$axios.post(that.$store.state.platformApi+"roles/used/"+row.id).then(result => {
        if(result.code==200){
          that.is_used_role = result.data;
        }
      })
    },
    deleteRole(){
      //删除角色
      let that = this;
      that.$axios.post(that.$store.state.platformApi+"roles/delete/"+that.currt_id).then(result => {
        // console.log(result);
        if(result.code==200){
          that.centerDialogVisible = false;
          that.getList();
          ElMessage({
            message: '已删除角色',
            type: 'success',
          })
        }
      })
    },
    handleDelete(index,row){
      //删除弹窗
      this.centerDialogVisible = true;
      this.currt_id = row.id;
    },
    typeFilter(value) {
      //过滤函数
      if(value=='ADMIN'){
        return '系统管理员'
      }else if(value=='USER'){
        return '普通用户'
      }
    },
    getLeafNodeIds(treeData, permissionIds) {
      // 收集树中所有非叶子节点（有children的节点）的ID
      let parentIds = new Set();
      const collectParentIds = (nodes) => {
        nodes.forEach(node => {
          if (node.children && node.children.length > 0) {
            parentIds.add(node.id);
            collectParentIds(node.children);
          }
        });
      };
      collectParentIds(treeData);
      
      // 过滤掉父级节点ID，只保留叶子节点ID用于回显
      return permissionIds.filter(id => !parentIds.has(id));
    },
    findNodeByName(treeData, name) {
      // 递归查找指定名称的节点
      for (const node of treeData) {
        if (node.name === name || node.label === name) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findNodeByName(node.children, name);
          if (found) return found;
        }
      }
      return null;
    },
  }
}
</script>

<style lang="scss" scoped>
.search_nav{
    width: 100%;
    height: 60px;
}
</style>